<template>
  <v-card>
    <v-card-title primary-title>
      <div>
        <div class="headline secondary--text">{{ $t('venue.list.title') }}</div>
        <span class="body-1 greyDarken1--text">{{ $t('venue.list.subtitle') }}</span>
      </div>
      <v-spacer></v-spacer>
     <VenueCreateDialog></VenueCreateDialog>
    </v-card-title>
    <v-card flat>
      <v-layout row wrap class="pa-3">
        <v-flex xs12 sm4 md4>
          <v-text-field
            append-outer-icon="search"
            v-model="search"
            :placeholder="$t('screener.venue.list.search.placeholder')"
            clear-inner-icon="rms_close"
            clearable
            single-line
            hide-details
            @click:clear="clearSearch"
            @click:append-outer="applySearch"
          ></v-text-field>
        </v-flex>
        <v-spacer></v-spacer>
      </v-layout>
      <v-card-text class="px-0">
        <v-data-table
          :headers="table_headers"
          :items="list.data"
          :loading="loading"
          :pagination.sync="pagination"
          :total-items="total"
          :rowsPerPageItems="rowsPerPageItems"
        >
          <template v-slot:items="props">
            <tr
              :style="{cursor: 'pointer'}"
              @click.stop="
                $router.push({
                  name: 'venue.update',
                  params: {
                    venue_id: props.item.id,
                  },
                })
              "
            >
              <td class="text-xs-left subheading">{{ props.item.id }}</td>
              <td class="text-xs-left">{{ props.item.image }}</td>
              <td class="text-xs-left">{{ props.item.name }}</td>
              <td class="text-xs-left">
                <v-chip class="secondary secondary--text font-weight-medium" small outline>
                  {{
                  DEFINES.SCREENER_STATUS[props.item.is_published]
                  }}
                </v-chip>
              </td>
              <td class="text-xs-left">{{ props.item.address }}</td>
              <td class="text-xs-left">
                <v-chip
                  small
                  color="primary"
                  outline
                  class="ma-0"
                  >
                  <b>{{ props.item.created_by == user.id ? $t("rms.you") : props.item.creator_email }}</b>
                  </v-chip>
                </td>
              <td class="text-xs-left">{{ fmtTime(props.item.created_at) }}</td>

              <td class="text-xs-center">
                <v-tooltip slot="append" top color="white">
                  <v-btn
                    slot="activator"
                    icon
                    small
                    dark
                    @click.stop="
                      $router.push({
                        name: 'venue.update',
                        params: {
                          venue_id: props.item.id,
                        },
                      })
                    "
                  >
                    <v-icon color="secondary">$vuetify.icons.rms_visibility</v-icon>
                  </v-btn>
                  <span class="greyDarken3--text body-1">
                    {{
                    $t('rms.tooltip.view')
                    }}
                  </span>
                </v-tooltip>

                <v-tooltip slot="append" top color="white">
                  <v-btn
                    slot="activator"
                    icon
                    small
                    dark
                    @click.stop="deleteConfirmation(props.item.id)"
                  >
                    <v-icon color="secondary">$vuetify.icons.rms_delete</v-icon>
                  </v-btn>
                  <span class="greyDarken3--text body-1">
                    {{
                    $t('rms.tooltip.delete')
                    }}
                  </span>
                </v-tooltip>
                <v-tooltip slot="append" top color="white">
                  <v-btn
                    slot="activator"
                    icon
                    small
                    dark
                    @click.stop="duplicateVenue(props.item.id)"
                  >
                    <v-icon color="secondary">mdi-content-copy</v-icon>
                  </v-btn>
                  <span class="greyDarken3--text body-1">
                    Duplicate venue
                  </span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
        <ConfirmationDialog
          :dialog="confirmation"
          @confirm="remove()"
          @cancel="confirmation = false"
        />
      </v-card-text>
    </v-card>
  </v-card>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import ConfirmationDialog from "@/components/dialogBox/Confirmation";
import i18n from "@/i18n";
import { utcToTz } from "@/helper";
import VenueCreateDialog from "./VenueCreateDialog"

export default {
  name: "VenueList",
  data() {
    return {
      search: "",
      total: 0,
      confirmation: false,
      loading: true,
      table_headers: [
        {
          text: i18n.t("venue.list.table.label.venue_id"),
          align: "left",
          sortable: true,
          value: "id"
        },
        {
          text: i18n.t("venue.list.table.label.image"),
          align: "left",
          sortable: false,
          value: "image"
        },
        {
          text: i18n.t("venue.list.table.label.name"),
          align: "left",
          sortable: true,
          value: "name"
        },
        {
          text: i18n.t("venue.list.table.label.published"),
          align: "left",
          sortable: false,
          value: "published"
        },
         {
          text: i18n.t("venue.list.table.label.address"),
          align: "left",
          sortable: false,
          value: "address"
        },
        {
          text: i18n.t("venue.list.table.label.created_by"),
          align: "left",
          sortable: true,
          value: "created_by"
        },
        {
          text: i18n.t("venue.list.table.label.created_at"),
          align: "left",
          sortable: true,
          value: "created_at"
        },
        {
          text: i18n.t("page.list.table.header.action"),
          align: "center",
          sortable: false,
          value: "action"
        }
      ],
      deleteVenueId: null,
      rowsPerPageItems: [5, 10, 25, 50, 100],
      pagination: {
        sortBy: 'created_at',
        descending: true,
        page: 1,
        rowsPerPage: 10,
      },
      search: '',
      loading: false,
      total: null,
      filters:{}
    };
  },
  created() {
    this.getApiData();
  },
  computed: {
    ...mapState({
      list: state => state.venue.list,
      company: state => state.company.company,
      user: (state) => state.user.profile,
    }),
    ...mapGetters("company", {
    timezone: "getSelectedCompanyTimezone",
  }),
  },
  components: { ConfirmationDialog, VenueCreateDialog },
  watch: {
    pagination: {
      handler: 'getApiData',
      deep: true,
    },
  },
  methods: {
    applySearch() {
      if (this.search.length) this.getApiData();
    },
    clearSearch() {
      this.search = "";
      this.getApiData();
    },
    getPaginationOffset: (recordPerPage, page) => recordPerPage * (page - 1),
    async getApiData() {
      this.loading = true;
      const { sortBy, descending, page, rowsPerPage } = this.pagination;
      var offset = this.getPaginationOffset(rowsPerPage, page);
      // Payload
      let payload = {
        offset: offset,
        limit: rowsPerPage,
        sort: sortBy,
        sorting_order: descending,
        search: this.search,
        filters: this.filters,
      };
      try {
        var response = await this.$store.dispatch("venue/list",payload);
        this.total = response.venues.total;
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR
        });
      }
      this.loading = false;
    },

    async remove() {
      try {
        await this.$store.dispatch("venue/delete", {
          id: this.deleteVenueId
        });
        this.getApiData();
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR
        });
      } finally {
        this.confirmation = false;
      }
    },
    async duplicateVenue(venueId) {
        await this.$store.dispatch("venue/duplicateVenue", {
          venue_id: venueId
        })
        .then((response) => {
          this.getApiData()
          this.$store.dispatch("app/showMessage", {
            message: 'New venue created successfully',
            color: this.DEFINES.SNACKBAR_SUCCESS_COLOR
          });
        })
        .catch((error) => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: this.DEFINES.SNACKBAR_ERROR_COLOR
          });
        });

    },

    deleteConfirmation(page_id) {
      this.deleteVenueId = page_id;
      this.confirmation = true;
    },

   fmtTime(input) {
      return utcToTz(input, this.timezone, 'MMMM Do YYYY, h:mm a');
    },
  }
};
</script>
